module.exports = __webpack_public_path__ + "static/flags/TD-81653b66ac570e97f337b603f13c8448.gif";